var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-progress progress"},[_c('div',{staticClass:"bar"},_vm._l((_vm.total),function(index){return _c('span',{key:index,class:`segment`,style:(_vm.getSegmentStyle(index))})}),0),_c('div',{staticClass:"count"},[_vm._v(_vm._s(_vm.progressText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }